/**
* Change all chart colors
*/
export const ChartConfig = {
  color: {
    'primary': '#43425D',
    'warning': '#FFB70F',
    'danger': '#ff5b3d',
    'success': '#5D92F4',
    'info': '#00D0BD',
    'white': '#fff',
    'lightGrey': '#E8ECEE'
  },
  lineChartAxesColor: '#E9ECEF',
  legendFontColor: '#AAAEB3', // only works on react chart js 2
  chartGridColor: '#EAEAEA',
  axesColor: '#657786',
  shadowColor: 'transparent',
  chartColors: [
    '#f9cde6',
    '#be7cb9',
    '#2b387c',
    '#479dcc',
    '#9dd0eb',
    '#ced1fc',
    '#f9cdd9',
    '#be7ca5',
    '#362b7c',
    '#4775cc',
    '#9db8eb',
    '#6264b0',
    '#ffba90',
    '#d43753',
    '#ff637b',
    '#ff90a3',
    '#512572',
    '#74559b'
  ]
}



// WEBPACK FOOTER //
// ./src/constants/chart-config.js